import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

/**
 * Temporary homepage announcement section.
 * Times are US Eastern (America/New_York): on 2026-04-14 the offset is EDT (UTC−4).
 */
const VISIBLE_UNTIL_MS = Date.parse('2026-04-14T16:00:00.000Z'); // Apr 14, 2026 12:00 PM Eastern

const PRESS_RELEASE_URL =
    'https://qgoldresources.com/news/q-gold-resources-provides-corporate-update-announces-preliminary-economic-assessment-pea-timeline-and-management-transition-to-advance-quartz-mountain-gold-project';
const WEBINAR_URL = 'https://us06web.zoom.us/meeting/register/0710C4SnTUWTxff5soUKkg';

function PeaAnnouncementSection() {
    if (Date.now() >= VISIBLE_UNTIL_MS) return null;

    return (
        <section className="pea-announcement-section py-5">
            <Container>
                <Row className="align-items-center text-center text-md-start">
                    <Col md={7} lg={8} className="mb-4 mb-md-0">
                        <h2 className="pea-announcement-section__title mb-3">
                            Q-Gold Announces Preliminary<br />Economic Assessment (PEA)
                        </h2>
                        <p className="pea-announcement-section__text mb-0">
                            Q-Gold has released the Preliminary Economic Assessment for the Q-Gold Project.
                            Management will review the results during a shareholder webinar on April 14.
                        </p>
                    </Col>
                    <Col md={5} lg={4} className="d-flex flex-column gap-3 align-items-center align-items-md-end">
                        <Button
                            variant="warning"
                            className="pea-announcement-section__cta-primary text-white fw-semibold w-100"
                            href={PRESS_RELEASE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Read the Press Release
                        </Button>
                        <Button
                            variant="outline-light"
                            className="pea-announcement-section__cta-secondary fw-semibold w-100"
                            href={WEBINAR_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Register for the Webinar
                        </Button>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default PeaAnnouncementSection;
